import { useMutation } from '@tanstack/react-query'

import API from '../../services/api'

export default function useForgotPasswordMutation() {
    return useMutation({ mutationFn: API.forgotPassword })
}
